import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Carrinho.module.css';
import CardCarrinho from './CardCarrinho';
import FooterOpcoes from './FooterOpcoes';
import ButtonVoltar from '../../../shared/components/ButtonVoltar';
import TipoEntrega from '../pages/TipoEntrega';
import FecharPedido from '../../caixa/pages/FecharPedido';
import ModalCobrarConta from '../../../shared/components/ModalCobrarConta';

function Carrinho() {
  const [itensCarrinho, setItensCarrinho] = useState([]);
  const [formaPagamento, setFormaPagamento] = useState('');
  const [mostrarFecharConta, setMostrarFecharConta] = useState(false);
  const navigate = useNavigate();

  const idMesa = localStorage.getItem('id_mesa');
  const mesaViaQrCode = !!localStorage.getItem('mesa_token_qrcode') && idMesa && idMesa !== 'null';

  // Carregar itens do localStorage
  useEffect(() => {
    const carrinho = JSON.parse(localStorage.getItem('carrinho')) || [];
    setItensCarrinho(carrinho);
  }, []);

  // Excluir item
  const excluirItem = (uuid) => {
    const carrinho = JSON.parse(localStorage.getItem('carrinho')) || [];
    const novoCarrinho = carrinho.filter((item) => item.uuid !== uuid);
    localStorage.setItem('carrinho', JSON.stringify(novoCarrinho));
    setItensCarrinho(novoCarrinho);

    // Dispara evento para atualizar o contador do carrinho
    window.dispatchEvent(new Event('carrinhoAtualizado'));
  };

  // Total
  const subtotal = itensCarrinho.reduce((total, item) => {
    const preco = parseFloat(item.preco || item.p_preco || 0);
    const qtd = item.quantidade || 1;
    return total + (isNaN(preco) ? 0 : preco * qtd);
  }, 0);

  const desconto = 0;
  const total = subtotal - desconto;

  return (
    <div className={styles.paginaCarrinho}>
      <ButtonVoltar to="/homecliente" />

      {/* Header */}
      <header className={styles.headercarrinho}>
        <h2>Meu Carrinho</h2>
      </header>

      {/* Container com scroll */}
      <div className={styles.scrollableContent}>
        {/* Itens do pedido */}
        <section className={styles.box}>
          <div className={styles.boxHeader}>
            <h3>Itens do Pedido</h3>
          </div>
          <div className={styles.carrinhoItens}>
            {itensCarrinho.length > 0 ? (
              itensCarrinho.map((item) => (
                <CardCarrinho
                  key={item.uuid}
                  id={item.uuid}
                  src={item.src}
                  label_title={item.label_title}
                  preco={item.preco || item.p_preco}
                  observacao={item.observacao || ''}
                  quantidade={item.quantidade || 1}
                  excluirItem={excluirItem}
                />
              ))
            ) : (
              <p className={styles.carrinhoVazio}>Seu carrinho está vazio.</p>
            )}
          </div>
        </section>

        <TipoEntrega/>

        {/* Forma de Pagamento */}
        <section className={styles.box}>
          <div className={styles.boxHeader}>
            <h3>Forma de Pagamento</h3>
          </div>
          <div className={styles.formaPagamento}>
            <div
              className={`${styles.pagamentoCard} ${formaPagamento === 'Dinheiro' ? styles.selecionado : ''}`}
              onClick={() => setFormaPagamento('Dinheiro')}
            >
              <span className={styles.icon}>💵</span>
              <span className={styles.label}>Dinheiro</span>
            </div>
            <div
              className={`${styles.pagamentoCard} ${formaPagamento === 'Cartão' ? styles.selecionado : ''}`}
              onClick={() => setFormaPagamento('Cartão')}
            >
              <span className={styles.icon}>💳</span>
              <span className={styles.label}>Cartão / Outro</span>
            </div>
          </div>
        </section>
      </div>

      {/* Resumo e Botão Fixos */}
      <div className={styles.fixedBottom}>
        <section className={styles.resumoBox}>
          <div className={styles.resumoLinhaItem}>
            <span>Subtotal</span>
            <span>R$ {subtotal.toFixed(2)}</span>
          </div>
          {desconto > 0 && (
            <div className={styles.resumoLinhaItem} style={{color: '#43E97B'}}>
              <span>Desconto</span>
              <span>- R$ {desconto.toFixed(2)}</span>
            </div>
          )}
          <div className={styles.resumoTotal}>
            <span>Total</span>
            <span>R$ {total.toFixed(2)}</span>
          </div>
        </section>

        {/* Botão de fechar pedido */}
        <div className={styles.botaoFinalizar}>
          <FecharPedido forma_de_pagamento={formaPagamento} total={total} />

          {mesaViaQrCode && (
            <button
              className={styles.btnPrimario}
              style={{ marginTop: 8 }}
              onClick={() => setMostrarFecharConta(true)}
            >
              Fechar Conta da Mesa
            </button>
          )}
        </div>
      </div>

      {mostrarFecharConta && (
        <ModalCobrarConta
          idMesa={Number(idMesa)}
          paymentOrigin="CLIENTE"
          onClose={() => setMostrarFecharConta(false)}
          onSuccess={() => {
            setMostrarFecharConta(false);
            localStorage.removeItem('id_mesa');
            localStorage.removeItem('mesa_token_qrcode');
            localStorage.removeItem('mesa_exige_cadastro');
            alert('Conta fechada com sucesso. Obrigado pela visita!');
            navigate('/home');
          }}
        />
      )}

      <FooterOpcoes typeView="cliente"/>
    </div>
  );
}

export default Carrinho;
